module.exports = "/_next/static/images/rolex_model_background_pink_landscape-64a50583bf10860c901cad0605bf33cd.jpg";